/**
 * Integration Id for SunCo Chat widget
 */
export const HELP_CENTER_SUNCO_INTEGRATION_ID_230130 =
  'HELP_CENTER_SUNCO_INTEGRATION_ID_230130';
